// Curriculum data helpers — builds TOPICS_MAP from JSON for a given class

export function buildTopicsMap(curriculumData, cls) {
  if (!curriculumData?.CBSE?.[String(cls)]) return {};
  const classData = curriculumData.CBSE[String(cls)];
  const topicsMap = {};
  for (const [subject, subjData] of Object.entries(classData)) {
    topicsMap[subject] = {};
    for (const chapter of subjData.chapters) {
      topicsMap[subject][chapter.name] = chapter.concepts.map(c => c.name);
    }
  }
  return topicsMap;
}

export function getAvailableSubjects(curriculumData, cls) {
  if (!curriculumData?.CBSE?.[String(cls)]) return ["Maths","Science","Geography"];
  return Object.keys(curriculumData.CBSE[String(cls)]);
}

export function findConceptDetails(curriculumData, cls, conceptName) {
  if (!curriculumData?.CBSE?.[String(cls)]) return null;
  const classData = curriculumData.CBSE[String(cls)];
  for (const subjData of Object.values(classData)) {
    for (const chapter of subjData.chapters) {
      for (const concept of chapter.concepts) {
        if (concept.name === conceptName || concept.id === conceptName) {
          return { ...concept, chapter: chapter.name };
        }
      }
    }
  }
  return null;
}

export const TOPICS_MAP_FALLBACK = {
  Maths: {"Algebra": ["Linear Equations","Quadratic Equations","Polynomials"],"Geometry": ["Triangles","Circles","Coordinate Geometry"]},
  Science: {"Physics": ["Motion","Force","Light","Sound"],"Chemistry": ["Matter","Reactions"],"Biology": ["Cell Structure","Life Processes"]},
  Geography: {"Physical Geography": ["Climate","Rivers"]},
  Economics: {"Basic Concepts": ["Development","Sectors"]},
};
